<template>
    <section style="margin: 18px;">
        <v-btn @click="OpenAddFAQs">Add Faqs</v-btn>
        <app-add-faqs ref="GetCourseDetailsList" :dialog='AddFAQDialog' @close='CloseDialog'></app-add-faqs>
        <app-faqs-table></app-faqs-table>
    </section>
</template>
<script>

import appAddFaqs from '../views/dialogs/AddFAQs'
import appFaqsTable from '../views/tables/FAQSTable'

export default {
   components:{
       appAddFaqs,
       appFaqsTable
   },
   data(){
       return {
           AddFAQDialog : false
       }
   },
   computed:{

   },
   methods:{
       OpenAddFAQs(){

           this.$refs.GetCourseDetailsList.GetCourseDetailsList()
           this.AddFAQDialog = true
       },
       CloseDialog(){

           this.AddFAQDialog = false
       }
   },
   mounted(){
       this.$eventHub.$emit("LOADING",'false')
   }
}
</script>
<style scoped>

</style>
